<template>
   <div>
    <b-sidebar style="background-color: red" id="sidebar-menu" backdrop backdrop-variant="dark" 
    aria-labelledby="sidebar-menu-title" no-header shadow>
      <template #default="{ hide }">
        <div class="p-3">
        <div class="d-flex align-items-center flex-column mb-3">
        <b-navbar-brand>
          <img
          src="../../../src/assets/images/dropsmart-logo.png"
          alt="Dropsmart Logo"
          >
          </b-navbar-brand>
        </div>
          <nav class="mb-3">
            <b-nav vertical>                            
              <b-nav-item
                v-for="(item, index) in menuItems" :key="index"  
                href="#" 
                @click="hide"
                v-on:click="itemSelected(index); goToUrl(item.route);">
                {{item.display}}
              </b-nav-item>

              <div class="divider-menu"></div>

              <b-nav-item href="#" @click="hide" v-on:click="$emit('navigate', 'CentreMyAccount'); navbarDisabled(null); goToUrl('CentreMyAccount');">My account details</b-nav-item>

              <div class="divider-menu"></div>

              <!-- <b-nav-item v-if="customerInfo && !customerInfo.user.paid" href="https://join.dropsmart.io/checkout?period=yearly" target="_blank" @click="hide">Upgrade</b-nav-item> -->
              <!-- <b-nav-item v-if="(customerLastSubscription && customerLastSubscription.status != 'ACTIVE')" href="https://join.dropsmart.io/checkout?period=yearly" target="_blank" @click="hide">Upgrade</b-nav-item> -->
              <b-nav-item v-if="customerInfo && shouldBehaveLikeFree" href="https://center.dropsmart.io/checkout?period=yearly" target="_blank" @click="hide">Upgrade</b-nav-item>


              <b-nav-item @click="hide" v-on:click="logoff()">Logout</b-nav-item>
            </b-nav>
          </nav>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "DropsmartCenterSideBar",
  props: ["page", "customerInfo", "menuItems", "customerLastSubscription"],
  data() {
    return {
      isActive: 0,
    };
  },
  computed: {
    shouldBehaveLikeFree() {
      console.log('shouldBehaveLikeFree: ' + this.customerInfo.user.paid);
      if(this.customerInfo && this.customerInfo.user && !this.customerInfo.user.paid) {
        if(this.activeOrCancelingSubscription) {
          return false;
        }
        else if(this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying trial ended
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription && !this.customerLastSubscription.status) {
        return false;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
  },
  methods: {
    itemSelected(index) {
      this.$root.$emit(
        "item-selected",
        index
      );
    },
    navbarDisabled(value) {
      this.$root.$emit(
        "item-disable",
        value
      );
    },
    goToUrl(sectionName) {
      if (sectionName === 'App') {
        window.open('https://app.dropsmart.io/', '_blank', 'noreferrer');
      } else {
        // If it is a FREE user, do not give access to Academy, Premium, or LiveQA pages
        if (  !this.customerInfo.user.paid
            && (sectionName == 'Academy' || sectionName == 'Premium' || sectionName == 'LiveQA') ) {
              sectionName = 'Perks';
        }
        this.$emit('navigate', sectionName);
        this.$router.push({
          name: sectionName,
        }).catch(()=>{});
      }
    },
    logoff: function() {
      sessionStorage.setItem("customerInfo", null);
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">

img {
  width: 70%;
}

.nav-item > .nav-link {
  color: #838383;

  &:hover {
    color: black;
  }
}

.divider-menu {
  border: 1px solid #838383;
  margin: 1.4rem 1rem;
}

</style>
